import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { useAuth } from '../../contexts/AuthContext';

const Layout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  
  // Pages that don't need the full layout (auth pages, error pages)
  const noLayoutPages = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/404',
    '/401',
    '/500'
  ];
  
  const isNoLayoutPage = noLayoutPages.some(page => 
    location.pathname.startsWith(page)
  );
  
  // If it's a no-layout page or user is not authenticated, just render the children
  if (isNoLayoutPage || !user) {
    return (
      <div className="min-h-screen bg-slate-50">
        {children}
      </div>
    );
  }
  
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />
      <div className="flex flex-1">
        <Sidebar />
        <main className="flex-1 min-w-0 p-6 lg:p-8">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;